import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

export const ArrowRight = createSvgIcon(
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.3333 12L15.3333 8L11.3333 4"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
    <path
      d="M0 8H15.3333"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
  </svg>,
  'ArrowRight'
);
